import { Injectable, signal } from '@angular/core';
import {UserNavigationLinks} from '../interfaces/user.interfaces';

@Injectable({ providedIn: 'root' })
export class UserLinksStateService {
  userLinks = signal<{items: UserNavigationLinks[], totalCount: number}>({items: [], totalCount: -1});
}
